import { CaretDown, SpinnerGap } from "@phosphor-icons/react";
import { Icon } from "@phosphor-icons/react";
import { ReactNode } from "react";

interface SelectFieldProps {
  label: string;
  placeholder: string;
  /** Rendered when a value is selected. Falls back to the placeholder. */
  value?: ReactNode;
  icon?: Icon;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  loadingText?: string;
}

/**
 * A form-field-looking button that opens a picker modal. Mirrors the "tap to
 * choose" pattern (provider / plan selectors) so the page stays short.
 */
const SelectField = ({
  label,
  placeholder,
  value,
  icon: LeadingIcon,
  onClick,
  disabled,
  loading,
  loadingText = "Loading...",
}: SelectFieldProps) => {
  const hasValue = value !== undefined && value !== null && value !== "";

  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm font-medium text-gray-700">{label}</label>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled || loading}
        className="flex items-center justify-between gap-3 w-full rounded-xl border border-gray-300 shadow-sm px-4 py-3 text-left transition hover:border-visaro-orange/60 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:border-gray-300"
      >
        <span className="flex items-center gap-2 min-w-0">
          {LeadingIcon && (
            <span className="w-8 h-8 rounded-full bg-visaro-orange/10 text-visaro-orange flex items-center justify-center shrink-0">
              <LeadingIcon size={16} weight="bold" />
            </span>
          )}
          <span
            className={`truncate ${
              hasValue ? "font-medium text-gray-900" : "text-gray-400"
            }`}
          >
            {loading ? loadingText : hasValue ? value : placeholder}
          </span>
        </span>
        {loading ? (
          <SpinnerGap className="animate-spin text-visaro-orange shrink-0" />
        ) : (
          <CaretDown className="text-gray-400 shrink-0" />
        )}
      </button>
    </div>
  );
};

export default SelectField;
